const FREE_EMAIL_DOMAINS = new Set([
  "gmail.com",
  "googlemail.com",
  "hotmail.com",
  "hotmail.es",
  "hotmail.com.ar",
  "outlook.com",
  "outlook.es",
  "live.com",
  "live.com.ar",
  "msn.com",
  "yahoo.com",
  "yahoo.es",
  "yahoo.com.ar",
  "ymail.com",
  "icloud.com",
  "me.com",
  "mac.com",
  "aol.com",
  "proton.me",
  "protonmail.com",
  "pm.me",
  "gmx.com",
  "gmx.es",
  "zoho.com",
  "mail.com",
  "yandex.com",
  "yandex.ru",
  "yopmail.com",
  "mailinator.com",
  "guerrillamail.com",
  "10minutemail.com",
  "tempmail.com",
  "temp-mail.org",
  "trashmail.com",
  "dispostable.com",
  "fastmail.com",
  "hey.com",
  "tutanota.com",
  "tutamail.com",
  "ctemplar.com",
  "skiff.com",
  "startmail.com",
  "runbox.com",
  "posteo.de",
  "posteo.net",
  "qq.com",
  "163.com",
  "126.com",
  "sina.com",
  "sohu.com",
  "foxmail.com",
  "hotmail.fr",
  "hotmail.de",
  "hotmail.co.uk",
  "outlook.fr",
  "outlook.de",
  "outlook.co.uk",
  "live.fr",
  "live.de",
  "live.co.uk",
  "yahoo.fr",
  "yahoo.de",
  "yahoo.co.uk",
  "yahoo.com.br",
  "yahoo.com.mx",
  "bol.com.br",
  "uol.com.br",
  "ig.com.br",
  "terra.com.br",
  "r7.com",
  "globo.com",
  "personal.com",
  "speedy.com.ar",
  "fibertel.com.ar",
  "arnet.com.ar",
  "ciudad.com.ar",
  "cablenet.com.ar",
  "mvdsl.com.ar",
  "abv.bg",
  "libero.it",
  "alice.it",
  "virgilio.it",
  "tin.it",
  "web.de",
  "freenet.de",
  "gmx.de",
  "gmx.net",
  "gmx.at",
  "gmx.ch",
  "bluewin.ch",
  "orange.fr",
  "wanadoo.fr",
  "sfr.fr",
  "free.fr",
  "laposte.net",
  "hotmail.it",
  "outlook.it",
  "live.it",
  "yahoo.it",
  "ntlworld.com",
  "btinternet.com",
  "sky.com",
  "talktalk.co.uk",
  "virginmedia.com",
  "optonline.net",
  "rogers.com",
  "bell.net",
  "telus.net",
  "shaw.ca",
  "sympatico.ca",
  "cox.net",
  "charter.net",
  "comcast.net",
  "verizon.net",
  "att.net",
  "earthlink.net",
  "juno.com",
  "netzero.net",
  "aim.com",
  "me.com.ar",
  "fibertel.com",
  "netscape.net",
  "rocketmail.com",
]);

export function isValidCorporateEmail(value: string): boolean {
  const email = value.trim().toLowerCase();
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return false;
  const domain = email.slice(email.lastIndexOf("@") + 1);
  return domain.length > 0 && !FREE_EMAIL_DOMAINS.has(domain);
}

export function getCorporateEmailError(value: string): string | null {
  const email = value.trim().toLowerCase();
  if (!email) return "El email es obligatorio";
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return "Ingresá un email válido";
  const domain = email.slice(email.lastIndexOf("@") + 1);
  if (FREE_EMAIL_DOMAINS.has(domain)) {
    return "Por favor, usá el email corporativo de tu empresa (no Gmail, Hotmail, Outlook, etc.)";
  }
  return null;
}

export { FREE_EMAIL_DOMAINS };
